/*eslint-disable */

import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/extra.css';
import './assets/fonts/alien/stylesheet.css';
import './assets/fonts/sylfaen/styles.css';
import './assets/fonts/acssans/stylesheet.css';
import './assets/fonts/beon/stylesheet.css';
import './assets/fonts/myrid-pro/stylesheet.css';
import './assets/fonts/strasua-regular/styles.css';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'

import App from './App/index';
import Meta from 'vue-meta';
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import VeeValidate from 'vee-validate';
import Vue from 'vue'
import VueAxios from 'vue-axios'
import VueRouter from 'vue-router';
import axios from 'axios'
import customDirective from './_helpers/custom.directive';
import jQueryTouch from "./assets/wall-street/js/jquery.ui.touch-punch.min.js"
import jQueryUI from "./assets/wall-street/js/jquery-ui.min.js"
import router from './route';
import store from './store/store.js';
import timestamp from './services/timestamp';

Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(Meta);
Vue.use(VeeValidate, {
  validity: true,
  required: true
});
Vue.use(VueAxios, axios);
Vue.use(PerfectScrollbar)

// Bus
export const bus = new Vue();

var $ = window.jQuery = require('jquery');


if (navigator.userAgent.indexOf('Mac') > 0) {
  $('body').addClass('mac');
}

new Vue({
  render: h => h(App),
  router: router,
  store: store,
  timestamp,
  jQueryUI,
  jQueryTouch
}).$mount('#app')